import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { parseOfficeJson } from '@/travelsuit/locations'
import { OfficeJson } from '@/types/location'

import { IAction } from '../actions/action-helpers'
import { AdminLocationsTypes } from '../actions/actions.types'

type AdminLocationsState = ApplicationState['adminLocations']

function adminLocationsReducer(state: AdminLocationsState = new ImmutableMap(), action: IAction): AdminLocationsState {
	switch (action.type) {
		case AdminLocationsTypes.GetAdminLocations.SUCCESS:
			return (action.payload ?? []).reduce((newState: AdminLocationsState, location: OfficeJson) => {
				const locationPayload = parseOfficeJson(location)
				return locationPayload.id === null ? newState : newState.set(locationPayload.id, locationPayload)
			}, state)
		case AdminLocationsTypes.AddAdminLocation.SUCCESS:
			return state.set(action.payload.id, parseOfficeJson(action.payload))
		case AdminLocationsTypes.UpdateAdminLocation.SUCCESS:
			return state.set(action.payload.id, parseOfficeJson(action.payload))
		case AdminLocationsTypes.RemoveAdminLocation.SUCCESS:
			return state.delete(action.requestPayload.id)
	}
	return state
}

export default adminLocationsReducer
